import { useSelector } from 'react-redux';
import { cn } from '@design-system';
import {
  parseCustomDisclosures,
  getCustomDisclosuresTitle,
  type DisclosureParagraph,
} from '@shared';
import { selectSessionAdvisor } from '@/model';

interface AdvisorCustomDisclosuresProps {
  className?: string;
}

function renderParagraph(paragraph: DisclosureParagraph, key: number) {
  return (
    <p key={key}>
      {paragraph.map((segment, i) => {
        if (segment.type === 'link') {
          return (
            <a
              key={i}
              href={segment.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-dark underline"
            >
              {segment.content}
            </a>
          );
        }
        return <span key={i}>{segment.content}</span>;
      })}
    </p>
  );
}

export function AdvisorCustomDisclosures({ className }: AdvisorCustomDisclosuresProps) {
  const advisor = useSelector(selectSessionAdvisor);
  const paragraphs = parseCustomDisclosures(advisor?.customDisclosures);

  if (paragraphs.length === 0) return null;

  const organizationName = advisor?.organizationDisplayName || advisor?.organizationName;
  const title = getCustomDisclosuresTitle(organizationName);

  return (
    <div
      className={cn(
        'bg-muted text-foreground mx-auto mt-2 max-w-5xl flex-none rounded-lg border p-3 text-xs font-light italic',
        className,
      )}
    >
      <p className="mb-1 text-xs font-semibold uppercase not-italic tracking-wide text-primary">
        {title}
      </p>
      <div className="space-y-2 wrap-break-word">{paragraphs.map(renderParagraph)}</div>
    </div>
  );
}
